import React from 'react';
import SAInputComponent from "./SAInputComponent";
import SATextArea from "./SATextArea";

class SATextAreaLabel extends React.Component {

  render() {
    const {name, label, value, onChange, error, ...attributes} = this.props;

    return (
      <SAInputComponent label={label}>
        <SATextArea name={name} autosize={true} onChange={onChange} value={value} error={error} {...attributes}/>
      </SAInputComponent>
    )
  }

}

export default SATextAreaLabel;
